/** biome-ignore-all lint/nursery/useExplicitType: Zod schema inference */
import { z } from 'zod';
import type { IAPI } from '../../apiResponse';
import { createApiResponseSchema } from '../../apiResponse';

export const challengeNarrowV3Schema = z.object({
  id: z.number(),
  slug: z.string(),
  type: z.string(),
  language: z.string(),
  title: z.string(),
  cefrLevel: z.string(),
  frequencyBand: z.string().nullable(),
  partOfSpeech: z.string(),
  definition: z.string(),
  definitionSimple: z.string().nullable(),
  register: z.string(),
  grammarPattern: z.string().nullable(),
  usageNotes: z.string().nullable(),
  examples: z.string(),
  collocations: z.string().nullable(),
  synonyms: z.string().nullable(),
  antonyms: z.string().nullable(),
  commonMistakes: z.string(),
  mnemonicHint: z.string().nullable(),
  ipaUk: z.string().nullable(),
  ipaUs: z.string().nullable(),
  imageUrl: z.string().nullable(),
  titleAudioUrl: z.string().nullable(),
  definitionAudioUrl: z.string().nullable(),
  usageNotesAudioUrl: z.string().nullable(),
  updatedAt: z.number(),
});

export type IChallengeV3 = z.infer<typeof challengeNarrowV3Schema>;

export const getPublicChallengeBySlugV3ResponseSchema = createApiResponseSchema(
  challengeNarrowV3Schema,
) as z.ZodSchema<IAPI<IChallengeV3>>;

export type IGetPublicChallengeBySlugV3Response = IAPI<IChallengeV3>;
